<template>
  <div
    class="worksheetsWrap mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="sheetsContent commonOrderContent">
      <div class="formBox">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-select v-model="formInline.source" placeholder="请选择">
              <el-option
                v-for="item in sourceList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="formInline.searchTxt"
              placeholder="请输入搜索内容"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="时间范围">
            <el-date-picker
              v-model="formInline.timeData"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              unlink-panels
              format="yyyy-MM-dd"
              value-format="timestamp"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="工单级别">
            <el-select v-model="formInline.level" clearable>
              <el-option
                v-for="item in levelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="
                currentPage = 1;
                getAllList();
              "
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button @click="resetClick">重置</el-button>
          </el-form-item>
          <template v-if="roleAuthority">
            <el-form-item style="margin-left: 50px">
              <el-button
                type="warning"
                icon="el-icon-plus"
                @click="
                  dialogVisible = true;
                  activeItem = {};
                "
                >创建工单</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button @click="batchOperation">批量操作</el-button>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div class="tabCardBox">
        <el-tabs
          type="border-card"
          style="height: 100%"
          v-model="selectTab"
          @tab-click="changeTab"
        >
          <el-tab-pane
            :label="v.name"
            v-for="v in cardList"
            :key="v.key"
            style="height: 100%"
          >
            <div class="orderCardItem">
              <el-table
                ref="drawTable"
                :data="tableData"
                stripe
                border
                style="width: 100%"
                class="tabWrap"
                height="90%"
                :header-cell-style="{
                  'background-color': '#F7F7F7',
                }"
                :cell-style="cellStyle"
                @selection-change="handleSelectionChange"
                :row-key="getRowKeys"
              >
                <el-table-column
                  type="selection"
                  width="50"
                  align="center"
                  reserve-selection
                  :selectable="selectable"
                >
                </el-table-column>
                <el-table-column
                  prop="time"
                  label="创建时间"
                  align="center"
                  width="125"
                >
                </el-table-column>
                <el-table-column
                  prop="description"
                  label="工单名称"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      v-if="
                        scope.row.description &&
                        scope.row.description.length >= 8
                      "
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.description"
                        placement="top-start"
                      >
                        <div>{{ scope.row.description }}</div>
                      </el-tooltip>
                    </span>
                    <span v-else>{{ scope.row.description }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="level"
                  label="工单级别"
                  align="center"
                  width="80"
                >
                </el-table-column>
                <el-table-column prop="remark" label="工单描述" align="center">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.remark && scope.row.remark.length >= 10"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.remark"
                        placement="top-start"
                      >
                        <div>{{ scope.row.remark }}</div>
                      </el-tooltip>
                    </span>
                    <span v-else>{{ scope.row.location }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="location"
                  label="地点"
                  align="center"
                  min-width="50"
                  :show-overflow-tooltip="true"
                >
                  <!-- <template slot-scope="scope">
                    <span v-if="scope.row.location && scope.row.location.length >= 8">
                      <el-tooltip class="item" effect="dark" :content="scope.row.location" placement="top-start">
                        <div>{{ scope.row.location }}</div>
                      </el-tooltip>
                    </span>
                    <span v-else>{{ scope.row.location }}</span>
                  </template> -->
                </el-table-column>
                <el-table-column
                  prop="img"
                  label="图片"
                  align="center"
                  width="110"
                >
                  <template slot-scope="scope">
                    <el-image
                      v-for="(item, index) in scope.row.imgInfo"
                      :key="index"
                      style="width: 35px; height: 35px; margin-right: 5px"
                      :src="item.imgUrl"
                      :preview-src-list="[item.imgUrl]"
                    ></el-image>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createName"
                  label="报修人"
                  align="center"
                  min-width="50"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                  prop="createPhone"
                  label="联系电话"
                  align="center"
                  width="115"
                >
                </el-table-column>
                <el-table-column
                  prop="setStatus"
                  label="状态"
                  width="110"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-tag
                      size="medium"
                      :type="
                        scope.row.setStatus == '待派单' ||
                        scope.row.setStatus == '已关闭'
                          ? 'info'
                          : scope.row.setStatus == '待处理'
                          ? 'warning'
                          : scope.row.setStatus == '待重新派单'
                          ? 'danger'
                          : scope.row.setStatus == '已完成'
                          ? 'success'
                          : ''
                      "
                      >{{ scope.row.setStatus }}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="handlers"
                  label="处理人"
                  align="center"
                  min-width="50"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                  label="操作"
                  :width="cloumnWidth()"
                  align="center"
                >
                  <template slot-scope="scope">
                    <template v-if="roleAuthority">
                      <template
                        v-if="
                          scope.row.setStatus == '待派单' ||
                          scope.row.setStatus == '待重新派单' ||
                          scope.row.setStatus == '待处理'
                        "
                      >
                        <el-button
                          type="text"
                          size="small"
                          @click="closeOrder(scope.row)"
                          >关闭</el-button
                        >
                      </template>
                      <template v-if="scope.row.setStatus == '待派单'">
                        <el-button
                          type="text"
                          size="small"
                          @click="
                            dialogVisible = true;
                            activeItem = scope.row;
                          "
                          >派单</el-button
                        >
                      </template>
                      <template
                        v-if="
                          scope.row.setStatus == '待重新派单' ||
                          scope.row.setStatus == '待处理' ||
                          scope.row.setStatus == '待确认'
                        "
                      >
                        <el-button
                          type="text"
                          size="small"
                          @click="
                            dialogVisible = true;
                            activeItem = scope.row;
                          "
                          >重新派单</el-button
                        >
                      </template>
                      <template v-if="scope.row.setStatus == '待确认'">
                        <el-button
                          type="text"
                          size="small"
                          @click="confirmOrder(scope.row)"
                          >确认</el-button
                        >
                      </template>
                    </template>

                    <el-button
                      type="text"
                      size="small"
                      @click="detailsProcessing(scope.row, '详情')"
                      >详情</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      v-if="printPermissions"
                      @click="printWord(scope.row)"
                      >打印</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 30, 50]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="page.total"
                style="margin-top: 10px; text-align: right"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!---  打印工单的html  -->
      <div id="downloadOuterContainer">
        <div id="printRoot">
          <h6>{{ projectName }}报修申报单</h6>
          <table
            class="upTable"
            border="1px"
            cellspacing="0px"
            cellpadding="3px"
            align="center"
            bgcolor="#fff"
          >
            <tbody align="center">
              <tr class="tableTr">
                <td class="tableTitle">资产位置</td>
                <td colspan="7" class="contentTxt">
                  {{ activeItem.location }}
                </td>
              </tr>
              <tr>
                <td class="tableTitle">资产名称</td>
                <td colspan="7" class="contentTxt">
                  {{ activeItem.deviceName }}
                </td>
              </tr>
              <tr class="tableTr">
                <td class="tableTitle">申请人</td>
                <td colspan="3" class="contentTxt">
                  {{ activeItem.createName }}
                </td>
                <td class="tableTitle">保修日期</td>
                <td colspan="3" class="contentTxt">{{ activeItem.time }}</td>
              </tr>
              <tr>
                <td class="tableTitle">故障描述</td>
                <td colspan="7" class="contentTxt">
                  {{ activeItem.remark }}
                </td>
              </tr>
              <tr>
                <td class="tableTitle" rowspan="2">维修部</td>
                <td class="tableItem">故障是否属实</td>
                <td class="tableTitle" rowspan="2">其他故障描述</td>
                <td class="tableItem" rowspan="2"></td>
                <td class="tableTitle" rowspan="2">接收时间</td>
                <td class="tableItem" rowspan="2"></td>
                <td class="tableTitle" rowspan="2">接收人签字</td>
                <td class="tableItem" rowspan="2"></td>
              </tr>
              <tr>
                <td>
                  <el-checkbox>是</el-checkbox>
                  <el-checkbox>否</el-checkbox>
                </td>
              </tr>
              <tr>
                <td class="tableTitle" rowspan="2">资产管理部</td>
                <td class="tableItem" colspan="2">是否人为损坏</td>
                <td class="tableTitle">赔偿金额</td>
                <td class="tableTitle" rowspan="2">责任人签字确认</td>
                <td class="tableItem" rowspan="2"></td>
                <td class="tableTitle" rowspan="2">财务部收款确认</td>
                <td class="tableItem" rowspan="2"></td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-checkbox>是</el-checkbox> <el-checkbox>否</el-checkbox>
                </td>
                <td>￥______</td>
              </tr>
              <tr>
                <td class="tableTitle">维修完成</td>
                <td class="tableTitle">责任人签字确认</td>
                <td class="tableItem" colspan="2"></td>
                <td class="tableTitle">资产管理入库确认</td>
                <td class="tableItem" colspan="3"></td>
              </tr>
            </tbody>
            <tfoot align="center"></tfoot>
          </table>
        </div>
      </div>
    </div>
    <!-- 创建工单 -->
    <DialogForm
      :dialogVisible="dialogVisible"
      v-if="dialogVisible"
      :activeItem="activeItem"
      :userAllList="userAllList"
    />
    <!-- 工单详情 -->
    <el-drawer
      :visible.sync="drawerState"
      v-if="orderDetails"
      title="详情"
      class="drawerWrap"
      size="30%"
      :before-close="handleClose"
    >
      <OrderDetails :activeItem="activeItem" />
    </el-drawer>
    <!-- 操作确认框 -->
    <HandleDialogCom
      v-if="handleDialog"
      :activeItem="activeItem"
      :userAllList="userAllList"
    />
  </div>
</template>

<script>
import print from "print-js";
import DialogForm from "@/components/houqinguanli/gongdanguanli/DialogForm.vue";
import HandleDialogCom from "@/components/houqinguanli/gongdanguanli/HandleDialogCom.vue";
import OrderDetails from "@/components/houqinguanli/gongdanguanli/OrderDetails";
import api from "@/api";
import {
  dateFtt,
  matchingOrderSource,
  matchingOrderColor,
  judgeAuthority,
} from "@/assets/js/utils";
import { handleWrokOrderData } from "@/assets/utils/handleData";
export default {
  components: {
    DialogForm,
    HandleDialogCom,
    OrderDetails,
  },
  data() {
    return {
      printPermissions: false,
      projectName: JSON.parse(window.sessionStorage.getItem("userInfo"))
        .projects[0].projectName,
      printData: {
        printable: "printRoot",
        ignore: ["no-print"],
      },
      downloadItem: {},
      userAllList: [],
      levelList: [
        { value: "HIGH", label: "紧急" },
        { value: "MEDIUM", label: "重要" },
        { value: "LOW", label: "一般" },
      ],
      user: [],
      sourceList: [{ value: "", label: "全部来源", name: "全部来源" }],
      formInline: {
        searchTxt: "",
        timeData: [],
        source: "",
        level: "",
      },
      dialogVisible: false,
      selectTab: "",
      cardList: [
        { name: "全部状态", key: "" },
        { name: "待派单", key: "TOBE_ASSIGNED" },
        { name: "待重新派单", key: "TOBE_RE_ASSIGNED" },
        { name: "待处理", key: "TOBE_REPAIR" },
        { name: "待确认", key: "TOBE_CONFIRMED" },
        { name: "已完成", key: "COMPLETED" },
        { name: "已关闭", key: "INVALID" },
      ],
      tableData: [],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      orderDetails: false,
      drawerState: false,

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      activeItem: {},
      multipleSelection: [],
      handleDialog: false,
      roleAuthority: false,
    };
  },
  methods: {
    cloumnWidth() {
      if (this.roleAuthority && this.printPermissions) {
        return 180;
      } else if (!this.roleAuthority && !this.printPermissions) {
        return 70;
      } else {
        return 160;
      }
    },
    changeTab() {
      this.currentPage = 1;
      this.resetSelection();
      this.getAllList();
    },
    getRowKeys(row) {
      return row.id;
    },
    selectable(row) {
      return row.setStatus !== "已完成" && row.setStatus !== "已关闭";
    },
    // 批量操作
    batchOperation() {
      this.activeItem = this.multipleSelection;
      if (this.activeItem.length == 0) {
        this.$message.error("未选择工单!");
        return;
      }
      this.handleDialog = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleClose() {
      this.orderDetails = false;
      this.drawerState = false;
    },
    detailsProcessing(row, type) {
      this.activeItem = row;
      this.activeItem.clickType = type;
      this.orderDetails = true;
      this.$nextTick(() => {
        this.drawerState = true;
      });
    },
    confirmOrder(row) {
      this.$confirm(
        `${
          row.type == "H5"
            ? "确认后该工单处理完毕，并向报修人发送短信，是否确认?"
            : "确认后该工单处理完毕，是否确认?"
        }`,
        "确认工单",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          return new Promise(async (resolve) => {
            let res = await api.logisticsOrderOperation({
              id: row.id,
              status: "COMPLETED",
              action: "CONFIRM",
            });
            if (res && res.data.code == 200) {
              this.$message.success("工单已完成");
              this.resetSelection();
              this.$store.commit("SET_LOADING", true);
              setTimeout(() => {
                this.getAllList();
              }, 500);
            }
            resolve();
          });
        })
        .catch(() => {});
    },
    resetSelection() {
      this.multipleSelection = [];
      this.$refs.drawTable.forEach((v) => {
        v.clearSelection();
      });
    },
    closeOrder(row) {
      this.activeItem = row;
      this.handleDialog = true;
    },
    cellStyle(row) {
      if (row.column.label === "工单级别") {
        return matchingOrderColor(row.row.level);
      }
      if (row.column.label === "创建时间") {
        return "font-size:12px";
      }
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getAllList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAllList();
    },
    resetClick() {
      this.formInline.searchTxt = "";
      this.formInline.timeData = [];
      this.formInline.source = "";
      this.formInline.level = "";
    },
    async getAllList() {
      this.tableData = [];
      this.$store.commit("SET_LOADING", true);
      if (this.formInline.timeData && this.formInline.timeData.length) {
        if (
          dateFtt("yyyy-MM-dd", new Date(this.formInline.timeData[1])) ===
          dateFtt("yyyy-MM-dd", new Date())
        ) {
          this.formInline.timeData[1] = new Date(
            dateFtt("yyyy-MM-dd hh:mm:ss", new Date())
          ).getTime();
        } else {
          this.formInline.timeData[1] = new Date(
            dateFtt(
              "yyyy-MM-dd 23:59:59",
              new Date(this.formInline.timeData[1])
            )
          ).getTime();
        }
      }
      let res = await api.logisticsOrderList({
        pageSize: this.page.size,
        page: this.currentPage - 1,
        textSearch: this.formInline.searchTxt,
        startTs: this.formInline.timeData ? this.formInline.timeData[0] : "",
        endTs: this.formInline.timeData ? this.formInline.timeData[1] : "",
        type: this.formInline.source,
        planStatus:
          this.selectTab == 0 ? "" : this.cardList[this.selectTab].key,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        priority: this.formInline.level,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableData = handleWrokOrderData(res.data.data.data);
        this.page.total = res.data.data.totalElements;
      }
    },
    async getUserList() {
      let res = await api.projectGetUserListByPower({
        permission: "houqinguanli:worksheets:edit",
      });
      if (res && res.data.code == 200) {
        this.userAllList = res.data.data;
      }
    },
    async getSource() {
      let res = await api.logisticsOrderGetSource({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.sourceList = this.sourceList.concat(res.data.data);
        this.sourceList.map((v) => {
          if (v.name !== "全部来源") {
            v.value = v.value.join(",");
            v.label = matchingOrderSource(v.name);
          }
        });
      }
    },
    handlePrint(params) {
      printJS({
        printable: params.printable, // 'printFrom', // 标签元素id
        type: params.type || "html",
        header: params.header, // '表单',
        targetStyles: ["*"],
        style: "@page {margin:0 10mm};", // 可选-打印时去掉眉页眉尾
        ignoreElements: params.ignore || [], // ['no-print']
        properties: params.properties || null,
      });
    },
    // 打印
    printWord(row) {
      this.activeItem = row;
      this.$nextTick(() => {
        document.getElementById("downloadOuterContainer").style.display =
          "block";
        this.handlePrint(this.printData);
        document.getElementById("downloadOuterContainer").style.display =
          "none";
      });
    },
  },
  created() {
    this.printPermissions =
      JSON.parse(
        window.sessionStorage.getItem("userInfo")
      ).projects[0].pageSettings.findIndex((v) => {
        return v.pageName == "workOrderPrinting";
      }) !== -1
        ? true
        : false;
    this.getSource();
    this.roleAuthority = judgeAuthority("houqinguanli:worksheets:edit");
    this.getUserList();
    this.formInline.searchTxt = this.$route.query.id
      ? this.$route.query.id
      : "";
    this.getAllList();
  },
};
</script>

<style lang="scss" scoped>
.worksheetsWrap {
  @include setFlexCenter;
  position: relative;
  #downloadOuterContainer {
    position: absolute;
    top: 100px;
    left: 200px;
    opacity: 0.1;
    width: 830px; /* no */
    display: none;
    #printRoot {
      width: 830px; /* no */
      h6 {
        margin: 20px 0;
        font-size: 20px;
        text-align: center;
      }
      .upTable {
        width: 100%;
        td {
          padding: 10px 0;
        }
        .tableTitle {
          width: 100px;
        }
        .tableItem {
          width: 120px;
        }
        .contentTxt {
          text-align: left;
          text-indent: 20px;
        }
      }
    }
  }

  ::v-deep .cell {
    .el-tooltip {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }

  .sheetsContent {
    width: 98%;
    height: 96%;

    ::v-deep .el-select .el-input {
      width: 120px;
    }

    ::v-deep .el-tabs__content {
      height: calc(100% - 50px);
    }
  }

  ::v-deep .el-descriptions {
    th {
      width: 120px;
    }
  }
}
</style>
